import axiosInstance from "../../utils/AxiosInstance";
import { clearAuth } from "../../utils/authStorage";

export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";

export const loginUser = (userData) => ({
  type: LOGIN_USER,
  payload: userData,
});

export const logoutUser = () => async (dispatch) => {
  try {
    await axiosInstance.post("/security/auth/logout");
  } catch {
    // Even if the call fails (network down, cookie already expired -> 401),
    // we still want to wipe local state so the UI reflects logged-out.
  } finally {
    clearAuth();
    dispatch({ type: LOGOUT_USER });
  }
};